// extracted by mini-css-extract-plugin
export default {"searchInputWrapper":"CustomSearchBox-module--search-input-wrapper--b39d6","searchInputIcon":"CustomSearchBox-module--search-input-icon--94462"};